export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/Users/diongrendelman/Projects/qonnected/order-street-web1/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/Users/diongrendelman/Projects/qonnected/order-street-web1/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/thank-you',
    name: '/thank-you',
    component: () => import('/Users/diongrendelman/Projects/qonnected/order-street-web1/src/pages/thank-you.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

